import Stack from './Stack';

export default class UndoStack extends Stack {
}
